<app-browse-filters class="app-filters" [class.app-mobile-hidden]="browseService.activeMobilePanel != 'filters'"></app-browse-filters>

<div class="app-browse-wrapper">
  <app-browse-toolbar></app-browse-toolbar>
  <app-browse-results [class.app-mobile-hidden]="browseService.activeMobilePanel == 'filters'"></app-browse-results>
</div>